import baseMixin from './baseMixin'
import { tween, timeline } from 'popmotion'

export default {
    mixins: [baseMixin],

    beforeCreate() {
        this.baseElementQueryString = 'speed-iteration-graphic'
    },

    methods: {
        setStyler() {
            this.spiral = this.stylerGroup('path')
        },

        initAction() {
            return tween({ from: 1, to: 0 })
        },

        animationAction() {
            return timeline(this.tweens())
        },

        tweens() {
            return this.spiral.map((_, i) => ({
                track: `spiral${i}`,
                from: { pathLength: 0, opacity: 1 },
                to: { pathLength: 100, opacity: 1 },
                duration: 300
            }))
        },

        initReaction(v) {
            this.spiral.forEach(s => s.set({ opacity: v }))
        },

        animationReaction(vs) {
            this.spiral.map((s, i) => s.set(vs[`spiral${i}`]))
        }
    }
}
